import React, { useEffect, useState } from 'react';
import Cookies from 'universal-cookie';

import { getConfig } from '@edx/frontend-platform';
import { Icon } from '@openedx/paragon';
import { Nightlight, WbSunny } from '@openedx/paragon/icons';
import { useIntl } from '@edx/frontend-platform/i18n';

function addPlugins(config, slot_name, plugins) {
  if (slot_name in config.pluginSlots === false) {
    config.pluginSlots[slot_name] = {
      keepDefault: true,
      plugins: []
    };
  }

  config.pluginSlots[slot_name].plugins.push(...plugins);
}
let themeVariant = 'selected-paragon-theme-variant';

const AddDarkTheme = () => {
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;

  const addDarkThemeToIframes = () => {
    const iframes = document.getElementsByTagName('iframe');
    const iframesLength = iframes.length;
    if (iframesLength > 0) {
      Array.from({ length: iframesLength }).forEach((_, index) => {
        const style = document.createElement('style');
        style.textContent = `
          body {
            background-color: #0D0D0E;
            color: #ccc;
          }
          a { color: #ccc; }
          a:hover { color: #d3d3d3; }
        `;
        if (iframes[index].contentDocument) {
          iframes[index].contentDocument.head.appendChild(style);
        }
      });
    }
  };

  useEffect(() => {
    const theme = window.localStorage.getItem(themeVariant);

    // - When page loads, Footer loads before MFE content. Since there is no iframe on page,
    // it does not append any class. MutationObserver observes changes in DOM and hence appends dark
    // attributes when iframe is added. After 15 sec, this observer is destroyed to conserve resources. 
    // - It has been added outside dark-theme condition so that it can be removed on Component Unmount.
    // - Observer can be passed to `addDarkThemeToIframes` function and disconnected after observing Iframe.
    // This approach has a limitation: the observer first detects the iframe and then detects the docSrc. 
    // We need to wait for docSrc to fully load before appending the style tag.
    const observer = new MutationObserver(() => {
      addDarkThemeToIframes();
    });

    if (isThemeToggleEnabled && theme === 'dark') {
      document.documentElement.setAttribute('data-paragon-theme-variant', 'dark');

      observer.observe(document.body, { childList: true, subtree: true });
      setTimeout(() => observer?.disconnect(), 15000); // clear after 15 sec to avoid resource usage
    }

    return () => observer?.disconnect();
  }, []);

  return (<div />);
};

const DigiwindFooter = () => (
  <div className="wrapper wrapper-footer">
  <style>{`
    @media (min-width: 1001px) {
      .footer-bottom .powerby-section { flex: 1; }
      .footer-bottom .digiwind-logo { flex: 1; }
      .footer-bottom .digiwind-contacts { flex: 3; display: flex; justify-content: center; }
    }
  
  
    .wrapper-footer { padding: 45px 0; background: #1C2A45; }
    .wrapper-footer nav { display: flex; justify-content: center; }
  
  
    .tutor-indigo-footer {
      max-width: 1230px;
      margin-left: auto;
      margin-right: auto;
      box-sizing: border-box;
      padding: 0 15px;
    }
  
  
    .footer-listing-of-links {
      display: flex;
      list-style-type: none;
      padding-left: 0;
      margin-left: 0;
    }
  
  
    .footer-single-links {
      margin: 0;
      margin-right: 17px;
      line-height: 25px;
    }
  
  
    .footer-single-links a {
      text-decoration: none;
      color: #FFFFFF;
    }
  
  
    .footer-single-links a:hover {
      text-decoration: underline;
      text-underline-offset: 3px;
      color: #FFFFFF;
    }
  
  
    .footer-single-links:last-child { margin-right: 0; }
  
  
    .footer-bottom { display: flex; justify-content: space-between; }
  
  
    .footer-bottom .powerby-section .openedx-powered img { width: 100px; }
    .footer-bottom .digiwind-contacts a { margin-right: 10px; }
    .footer-bottom .digiwind-contacts a svg { width: 40px; height: 40px; }
    .footer-bottom .digiwind-logo img { height: 35px; }
  
  
    .sprite-svg-holder { display: none; }
  
  
    @media (max-width: 1000px) {
      .wrapper-footer { padding: 30px 0; }
      .tutor-indigo-footer { padding: 0 8px; }
      .footer-bottom { flex-direction: column; align-items: center; text-align: center; }
      .footer-bottom .digiwind-logo,
      .footer-bottom .digiwind-contacts { margin-top: 10px; }
    }
  
  
    @media (max-width: 600px) {
      .footer-listing-of-links { flex-direction: column; align-items: center; }
      .footer-single-links { margin-right: 0; margin-bottom: 8px; }
      .footer-single-links:last-child { margin-bottom: 0; }
    }
  `}</style>
  
  
  
  
  
    <footer className="tutor-indigo-footer">
      <div className="footer-top">
        <nav className="nav-colophon" aria-label="About">
          <ol class="footer-listing-of-links">
            <li class="footer-single-links"><a href="/about">About Us</a></li>
            <li class="footer-single-links"><a href="/tos">Terms of Service</a></li>
            <li class="footer-single-links"><a href="/privacy">Privacy Policy</a></li>
            <li class="footer-single-links"><a href="/contact">Contact Us</a></li>
          </ol>
        </nav>
      </div>
      <div className="footer-bottom">
        <div className="powerby-section">
          <div className="openedx-powered">
            <a href="https://open.edx.org">
              <img src="https://files.edx.org/openedx-logos/open-edx-logo-tag-dark.png" alt="Powered by Open edX" />
            </a>
          </div>
        </div>
        <div className="digiwind-contacts">
          {/* SVG sprite symbols */}
          <svg className="sprite-svg-holder" xmlns="http://www.w3.org/2000/svg">
            <symbol viewBox="0 0 35 35" id="ico-linkedin">
              <title>linkedin</title>
              <path fill="#73EDD6" d="M17.5 0C7.8 0 0 7.8 0 17.5S7.8 35 17.5 35 35 27.2 35 17.5C35 7.8 27.2 0 17.5 0zM13.1 26H8.8V10.7h4.4V26zM11.1 9.7c-1.1 0-2-0.9-2-2.1s0.9-2.1 2.1-2.1c1.1 0 2.1 0.9 2.1 2.1C13.1 8.8 12.2 9.7 11.1 9.7zM28.4 26h-4.4V16.5c0-1.1-0.3-1.9-1.7-1.9 -2.3 0-2.7 1.9-2.7 1.9v9.5h-4.4V10.7h4.4v1.5c0.6-0.5 2.2-1.5 4.4-1.5 1.4 0 4.4 0.8 4.4 6V26z" />
            </symbol>
            <symbol viewBox="0 0 35 35" id="ico-facebook">
              <title>facebook</title>
              <path fill="#73EDD6" d="M17.5 0C7.8 0 0 7.8 0 17.5S7.8 35 17.5 35 35 27.2 35 17.5C35 7.8 27.2 0 17.5 0zM23.6 9.6h-2.2c-0.8 0-1.4 0.2-1.6 0.5 -0.3 0.3-0.4 0.9-0.4 1.5v2.7h4.2l-0.5 4.2h-3.6v10.8h-4.3V18.5h-3.6V14.3h3.6v-3.1c0-1.8 0.5-3.1 1.5-4.1 1-1 2.3-1.5 3.9-1.5 1.4 0 2.5 0.1 3.2 0.2C23.6 5.9 23.6 9.6 23.6 9.6z" />
            </symbol>
            <symbol viewBox="0 0 35 35" id="ico-youtube">
              <title id="youtube-title">youtube</title>
              <path fill="#73EDD6"
                d="M15.2 24.5c0 0.3 0 0.5 0 0.6 0 0.2 0 0.2-0.1 0.3 0 0.2-0.2 0.3-0.4 0.4 -0.2 0.1-0.3 0-0.5-0.3 0 0 0-0.1 0-0.3 0-0.2 0-0.4 0-0.6l0-3.8h-1.4l0 3.8c0 0.3 0 0.5 0 0.7s0 0.4 0 0.5c0 0.2 0 0.3 0.1 0.5 0 0.2 0.1 0.3 0.3 0.5 0.2 0.1 0.4 0.2 0.6 0.2 0.2 0 0.4 0 0.7-0.1 0.2-0.1 0.4-0.2 0.6-0.3 0.2-0.1 0.3-0.3 0.4-0.4l0 0.8L16.7 26.8v-6.1h-1.4L15.2 24.5 15.2 24.5z"
              />
              <path fill="#73EDD6"
                d="M20.1 20.5c-0.3 0-0.7 0.2-1.2 0.5V18.6h-1.4v8.2l1.2 0 0.1-0.5c0.4 0.3 0.7 0.5 1 0.6 0.3 0.1 0.6 0 0.8-0.1 0.2-0.1 0.4-0.3 0.5-0.6 0.1-0.3 0.2-0.6 0.2-1v-3.2c0-0.6-0.2-1-0.6-1.3C20.5 20.5 20.3 20.5 20.1 20.5zM20.2 25.3c0 0.1-0.1 0.2-0.2 0.3 -0.1 0.1-0.3 0.1-0.4 0.1 -0.2 0-0.3 0-0.4-0.1 -0.1-0.1-0.2-0.2-0.2-0.3v-3.6c0-0.1 0.1-0.2 0.2-0.3 0.1-0.1 0.3-0.1 0.4-0.1 0.2 0 0.3 0 0.4 0.1 0.1 0.1 0.2 0.2 0.2 0.3V25.3z"
              />
              <polygon fill="#73EDD6"
                points="13.2 18.6 8.6 18.6 8.6 19.6 10.1 19.6 10.1 26.8 11.5 26.8 11.5 19.6 13.2 19.6 "
              />
              <path fill="#73EDD6"
                d="M17.5 0C7.8 0 0 7.8 0 17.5S7.8 35 17.5 35 35 27.2 35 17.5C35 7.8 27.2 0 17.5 0zM20 12.7V8.5h1.3v4.9c0 0.1 0 0.2 0.1 0.3 0.1 0.1 0.2 0.1 0.4 0.1 0.1 0 0.3 0 0.4-0.1 0.1-0.1 0.2-0.2 0.2-0.3V8.5h1.2v6.3h-1.6l0-0.5c-0.1 0.2-0.3 0.4-0.4 0.5 -0.2 0.1-0.3 0.2-0.5 0.2 -0.2 0-0.4-0.1-0.6-0.2 -0.1-0.1-0.3-0.2-0.4-0.4 0-0.1-0.1-0.2-0.1-0.3 0-0.1 0-0.2 0-0.3 0-0.1 0-0.2 0-0.4L20 12.7 20 12.7zM16.1 8.6c0.3-0.2 0.6-0.3 1.1-0.3 0.4 0 0.7 0.1 1 0.2 0.3 0.1 0.5 0.3 0.6 0.5 0.1 0.2 0.2 0.4 0.3 0.6 0.1 0.3 0.1 0.6 0.1 1v1.6c0 0.6 0 1-0.1 1.3 0 0.2-0.1 0.5-0.3 0.8 -0.2 0.3-0.4 0.4-0.6 0.5 -0.3 0.1-0.6 0.2-0.9 0.2 -0.3 0-0.7 0-0.9-0.2 -0.3-0.1-0.5-0.2-0.6-0.4 -0.1-0.2-0.2-0.4-0.3-0.7 -0.1-0.3-0.1-0.7-0.1-1.3 0 0 0-1.7 0-1.7 0-0.6 0.1-1 0.2-1.4C15.6 9 15.8 8.7 16.1 8.6zM11.9 6l0.9 3.1 0.9-3.1h1.7l-1.8 4.2v4.8H12.2v-4.8l-1.9-4.2H11.9zM27.8 26c0 0.4-0.1 0.8-0.3 1.2 -0.2 0.4-0.4 0.7-0.7 0.9 -0.3 0.3-0.7 0.5-1.1 0.6 -0.4 0.2-0.8 0.2-1.3 0.2H10.6c-0.5 0-0.9-0.1-1.3-0.2 -0.4-0.2-0.8-0.4-1.1-0.6 -0.3-0.3-0.6-0.6-0.7-0.9 -0.2-0.4-0.3-0.7-0.3-1.2v-6.8c0-0.4 0.1-0.8 0.3-1.2 0.2-0.4 0.4-0.7 0.7-0.9 0.3-0.3 0.7-0.5 1.1-0.6 0.4-0.2 0.8-0.2 1.3-0.2H24.4c0.5 0 0.9 0.1 1.3 0.2s0.8 0.4 1.1 0.6c0.3 0.3 0.6 0.6 0.7 0.9 0.2 0.4 0.3 0.7 0.3 1.2V26z"
              />
              <path fill="#73EDD6"
                d="M17.2 13.9c0.2 0 0.3-0.1 0.4-0.2 0.1-0.1 0.2-0.3 0.2-0.4V9.9c0-0.2-0.1-0.3-0.2-0.5 -0.1-0.1-0.3-0.2-0.4-0.2 -0.2 0-0.3 0.1-0.4 0.2 -0.1 0.1-0.2 0.3-0.2 0.5v3.4c0 0.2 0.1 0.3 0.2 0.4C16.9 13.9 17.1 13.9 17.2 13.9z"
              />
              <path fill="#73EDD6"
                d="M24.7 24.7v0.2 0.5c0 0.2-0.1 0.3-0.2 0.4 -0.1 0.1-0.3 0.1-0.4 0.1h-0.2c-0.2 0-0.3 0-0.4-0.1 -0.1-0.1-0.2-0.2-0.2-0.4v-0.1 -0.6 -0.8h2.5v-0.8c0-0.3 0-0.6 0-0.9 0-0.3 0-0.5-0.1-0.7 0-0.3-0.2-0.5-0.4-0.7 -0.2-0.2-0.5-0.3-0.7-0.3 -0.3-0.1-0.6-0.1-0.9 0 -0.3 0-0.5 0.1-0.8 0.3 -0.3 0.2-0.5 0.4-0.6 0.8 -0.1 0.3-0.2 0.8-0.2 1.3v1.9c0 0.8 0.2 1.4 0.6 1.7 0.4 0.3 0.8 0.5 1.2 0.5 0 0 0.1 0 0.1 0 0.5 0 0.9-0.2 1.3-0.6 0.3-0.3 0.4-0.6 0.4-1.1 0-0.1 0-0.3-0.1-0.5H24.7v0h0V24.7zM23.3 22.1c0-0.2 0.1-0.3 0.2-0.4 0.1-0.1 0.3-0.2 0.4-0.2h0.1c0.2 0 0.3 0.1 0.5 0.2 0.1 0.1 0.2 0.2 0.2 0.4l0 0.8h-1.4L23.3 22.1z"
              />
            </symbol>
          </svg>
          <div>
            <a href="https://www.linkedin.com/company/digiwind/" target="_blank" rel="noopener">
              <svg className="icon"><use xlinkHref="#ico-linkedin" /></svg>
            </a>
            <a href="https://www.youtube.com/@digiwind_project" target="_blank" rel="noopener">
              <svg className="icon"><use xlinkHref="#ico-youtube" /></svg>
            </a>
            <a href="https://www.facebook.com/people/DigiWind/61556691890618/" target="_blank" rel="noopener">
              <svg className="icon"><use xlinkHref="#ico-facebook" /></svg>
            </a>
          </div>
        </div>
        <div className="digiwind-logo">
          <a href="https://digiwind.com">
            <img src="https://digiwind.org/wp-content/uploads/2023/12/digiwind-logo-svg.svg" alt="Powered by Digiwind" />
          </a>
        </div>
      </div>
    </footer>
  </div>
);

async function setConfig () {
  let config = {
    pluginSlots: {}
  };

  try {
    /* We can't assume FPF exists, as it's not declared as a dependency in all
     * MFEs, so we import it dynamically. In addition, for dynamic imports to
     * work with Webpack all of the code that actually uses the imported module
     * needs to be inside the `try{}` block.
     */
    const { DIRECT_PLUGIN, PLUGIN_OPERATIONS } = await import('@openedx/frontend-plugin-framework');
const IndigoFooter = () => {
  const intl = useIntl();
  const config = getConfig();

  const indigoFooterNavLinks = config.INDIGO_FOOTER_NAV_LINKS || [];

  const messages = {
    "footer.poweredby.text": {
      id: "footer.poweredby.text",
      defaultMessage: "Powered by",
      description: "text for the footer",
    },
    "footer.tutorlogo.altText": {
      id: "footer.tutorlogo.altText",
      defaultMessage: "Runs on Tutor",
      description: "alt text for the footer tutor logo",
    },
    "footer.logo.altText": {
      id: "footer.logo.altText",
      defaultMessage: "Powered by Open edX",
      description: "alt text for the footer logo.",
    },
    "footer.copyright.text": {
      id: "footer.copyright.text",
      defaultMessage: `Copyrights ©${new Date().getFullYear()}. All Rights Reserved.`,
      description: "copyright text for the footer",
    },
  };

  return (
    <div className="wrapper wrapper-footer">
      <footer id="footer" className="tutor-container">
        <div className="footer-top">
          <div className="powered-area">
            <ul className="logo-list">
              <li>{intl.formatMessage(messages["footer.poweredby.text"])}</li>
              <li>
                <a
                  href="https://edly.io/tutor/"
                  rel="noreferrer"
                  target="_blank"
                >
                  <img
                    src={`${config.LMS_BASE_URL}/theming/asset/images/tutor-logo.png`}
                    alt={intl.formatMessage(
                      messages["footer.tutorlogo.altText"]
                    )}
                    width="57"
                  />
                </a>
              </li>
              <li>
                <a href="https://open.edx.org" rel="noreferrer" target="_blank">
                  <img
                    src={`${config.LMS_BASE_URL}/theming/asset/images/openedx-logo.png`}
                    alt={intl.formatMessage(messages["footer.logo.altText"])}
                    width="79"
                  />
                </a>
              </li>
            </ul>
          </div>
          <nav className="nav-colophon">
            <ol>
              {indigoFooterNavLinks.map((link) => (
                <li key={link.url}>
                  <a href={`${link.url.startsWith("http") ? link.url : config.LMS_BASE_URL + link.url}`}>{link.title}</a>
                </li>
              ))}
            </ol>
          </nav>
        </div>
        <span className="copyright-site">
          {intl.formatMessage(messages["footer.copyright.text"])}
        </span>
      </footer>
    </div>
  );
};
const MobileViewHeader = () => {
  const config = getConfig();
  const intl = useIntl();
  const messages = {
    "mobile.view.header.logo.altText": {
      id: "mobile.view.header.logo.altText",
      defaultMessage: "My Open edX",
      description: "alt text for the mobile view header logo",
    },
  };

  const BASE_URL = config.LMS_BASE_URL;

  return (
    <>
      <style>
        {`
          #root .logo-image.logo-white {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root .logo-image {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root .logo-white {
            display: block;
          }
        `}
      </style>
      <a href={`${BASE_URL}/dashboard`} title="Open edX" className="logo">
        <img className="logo-image" src={`${BASE_URL}/static/indigo/images/logo.png`} alt={intl.formatMessage(messages["mobile.view.header.logo.altText"])} />
        <img className="logo-image logo-white" src={`${BASE_URL}/static/indigo/images/logo-white.png`} alt={intl.formatMessage(messages["mobile.view.header.logo.altText"])} />
      </a>
    </>
  );
};
const ThemedLogo = () => {
  const BASE_URL = getConfig().LMS_BASE_URL;

  return (
    <>
      <style>
        {`
          #root header .logo-image.logo-white {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root header .logo-image {
            display: none;
          }
          [data-paragon-theme-variant="dark"] #root header .logo-white {
            display: block;
          }
        `}
      </style>
      <a href={`${BASE_URL}/dashboard`} title="Open edX" className="logo">
        <img className="logo-image" src={`${BASE_URL}/static/indigo/images/logo.png`} alt="Open edX" />
        <img className="logo-image logo-white" src={`${BASE_URL}/static/indigo/images/logo-white.png`} alt="Open edX" />
      </a>
    </>
  );
};
const ToggleThemeButton = () => {
  const intl = useIntl();
  const [isDarkThemeEnabled, setIsDarkThemeEnabled] = useState(false);

  const themeCookie = 'selected-paragon-theme-variant';
  const themeCookieExpiry = 90; // days
  const isThemeToggleEnabled = getConfig().INDIGO_ENABLE_DARK_TOGGLE;

  const getCookie = (name) => {
    return document.cookie
      .split("; ")
      .find((row) => row.startsWith(name + "="))
      ?.split("=")[1];
  };

  const setCookie = (name, value, { domain, path, expires }) => {
    document.cookie = `${name}=${value}; domain=${domain}; path=${path}; expires=${expires.toUTCString()}; SameSite=Lax`;
  };

  const serverURL = new URL(getConfig().LMS_BASE_URL);

  const getCookieExpiry = () => {
    const today = new Date();
    return new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate() + themeCookieExpiry
    );
  };

  const getCookieOptions = (serverURL) => ({
    domain: serverURL.hostname,
    path: '/',
    expires: getCookieExpiry(),
  });

  const onToggleTheme = () => {
    let theme = '';

    if (getCookie(themeCookie) === 'dark') {
      document.documentElement.setAttribute('data-paragon-theme-variant', 'light');
      setIsDarkThemeEnabled(false);
      theme = 'light';
    } else {
      document.documentElement.setAttribute('data-paragon-theme-variant', 'dark');
      setIsDarkThemeEnabled(true);
      theme = 'dark';
    }

    window.localStorage.setItem(themeCookie, theme);
    setTimeout(() => {
      setCookie(themeCookie, theme, getCookieOptions(serverURL));
      window.location.reload();
    }, 1);
  };

  useEffect(() => {
    if (!getCookie(themeCookie) || getCookie(themeCookie) === 'undefined') {
      return;
    }
    if (getCookie(themeCookie) !== window.localStorage.getItem(themeCookie)) {
      window.localStorage.setItem(themeCookie, getCookie(themeCookie));
      window.location.reload();
    }
  }, []);

  const handleKeyUp = (event) => {
    if (event.key === "Enter") {
      onToggleTheme();
    }
  };

  if (!isThemeToggleEnabled) {
    return <div />;
  }

  const messages = {
    "header.user.theme": {
      id: "header.user.theme",
      defaultMessage: "Toggle Theme",
      description: "Toggle between light and dark theme",
    },
  };

  return (
    <div className="theme-toggle-button mr-3">
      <div className="light-theme-icon">
        <Icon src={WbSunny} />
      </div>
      <div className="toggle-switch">
        <label htmlFor="theme-toggle-checkbox" className="switch">
          <input
            id="theme-toggle-checkbox"
            defaultChecked={getCookie(themeCookie) === "dark"}
            onChange={onToggleTheme}
            onKeyUp={handleKeyUp}
            type="checkbox"
            title={intl.formatMessage(messages["header.user.theme"])}
          />
          <span className="slider round" />
          <span id="theme-label" className="sr-only">{`Switch to ${isDarkThemeEnabled ? "Light" : "Dark"
            } Mode`}</span>
        </label>
      </div>
      <div className="dark-theme-icon">
        <Icon src={Nightlight} />
      </div>
    </div>
  );
};
    if (process.env.APP_ID == 'admin-console') {
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
    if (process.env.APP_ID == 'authn') {
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
    if (process.env.APP_ID == 'authoring') {

      // Currently there is no way to conditionally add plugin slot configuration from tutor-mfe.
      // So, as a workaround, tutor-contrib-aspects simply defines the components added to the plugin as empty components.
      const CourseOutlineSidebar = () => {};
      const UnitPageSidebar = () => {};
      const SidebarToggleWrapper = ({component}) => component;
      const CourseHeaderButton = () => {};
      const UnitActionsButton = () => {};
      const SubSectionAnalyticsButton = () => {};


const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_sidebar.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'outline-sidebar',
                    priority: 1,
                    type: DIRECT_PLUGIN,
                    RenderWidget: CourseOutlineSidebar,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_sidebar.v1', [
            {
                op: PLUGIN_OPERATIONS.Wrap,
                widgetId: 'default_contents',
                wrapper: SidebarToggleWrapper,
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_unit_sidebar.v2', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'course-unit-sidebar',
                    priority: 1,
                    type: DIRECT_PLUGIN,
                    RenderWidget: UnitPageSidebar,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_unit_sidebar.v2', [
            {
                op: PLUGIN_OPERATIONS.Wrap,
                widgetId: 'default_contents',
                wrapper: SidebarToggleWrapper,
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_unit_header_actions.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'unit-header-aspects-button',
                    priority: 60,
                    type: DIRECT_PLUGIN,
                    RenderWidget: CourseHeaderButton,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_header_actions.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'outline-header-aspects-button',
                    priority: 60,
                    type: DIRECT_PLUGIN,
                    RenderWidget: CourseHeaderButton,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_unit_card_extra_actions.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'units-action-aspects-button',
                    priority: 60,
                    type: DIRECT_PLUGIN,
                    RenderWidget: UnitActionsButton,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.authoring.course_outline_subsection_card_extra_actions.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'units-action-aspects-button',
                    priority: 60,
                    type: DIRECT_PLUGIN,
                    RenderWidget: SubSectionAnalyticsButton,
                },
            }]);
      addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
            {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
                id: 'custom_footer',
                type: DIRECT_PLUGIN,
                priority: 20,
                RenderWidget: () => (
                <DigiwindFooter />
                ),
            },
            
    }
  ]);
      addPlugins(config, 'desktop_secondary_menu_slot', [
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'theme_switch_button',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ToggleThemeButton,
                    },
                },
        ]);
      addPlugins(config, 'mobile_header_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                }
                ]);
      addPlugins(config, 'mobile_header_slot', [
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'theme_switch_button',
                        type: DIRECT_PLUGIN,
                        RenderWidget: MobileViewHeader,
                    },
                },
                ]);
      addPlugins(config, 'org.openedx.frontend.layout.studio_header_search_button_slot.v1', [
        {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
                priority: 10,
                id: 'custom_notification_tray_before',
                type: DIRECT_PLUGIN,
                RenderWidget: ToggleThemeButton,
            },
        },
        ]);
      addPlugins(config, 'org.openedx.frontend.layout.studio_footer.v1', [
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
        ]);
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
    if (process.env.APP_ID == 'account') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
            {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
                id: 'custom_footer',
                type: DIRECT_PLUGIN,
                priority: 20,
                RenderWidget: () => (
                <DigiwindFooter />
                ),
            },
            
    }
  ]);
      addPlugins(config, 'desktop_secondary_menu_slot', [
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'theme_switch_button',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ToggleThemeButton,
                    },
                },
        ]);
      addPlugins(config, 'mobile_header_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                }
                ]);
      addPlugins(config, 'mobile_header_slot', [
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'theme_switch_button',
                        type: DIRECT_PLUGIN,
                        RenderWidget: MobileViewHeader,
                    },
                },
                ]);
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
    if (process.env.APP_ID == 'communications') {
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
    if (process.env.APP_ID == 'discussions') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
            {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
                id: 'custom_footer',
                type: DIRECT_PLUGIN,
                priority: 20,
                RenderWidget: () => (
                <DigiwindFooter />
                ),
            },
            
    }
  ]);
      addPlugins(config, 'desktop_secondary_menu_slot', [
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'theme_switch_button',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ToggleThemeButton,
                    },
                },
        ]);
      addPlugins(config, 'mobile_header_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                }
                ]);
      addPlugins(config, 'mobile_header_slot', [
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'theme_switch_button',
                        type: DIRECT_PLUGIN,
                        RenderWidget: MobileViewHeader,
                    },
                },
                ]);
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
    if (process.env.APP_ID == 'gradebook') {
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
    if (process.env.APP_ID == 'learner-dashboard') {
const modifyLogoHref = (widget) => {
  widget.content.href = "https://digiwindcampus.org";
  return widget;
};

addPlugins(config, 'logo_slot', [
  {
    op: PLUGIN_OPERATIONS.Modify,
    widgetId: 'default_contents',
    fn: modifyLogoHref,
  },
]);

const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
            {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
                id: 'custom_footer',
                type: DIRECT_PLUGIN,
                priority: 20,
                RenderWidget: () => (
                <DigiwindFooter />
                ),
            },
            
    }
  ]);
      addPlugins(config, 'desktop_secondary_menu_slot', [
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'theme_switch_button',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ToggleThemeButton,
                    },
                },
        ]);
      addPlugins(config, 'mobile_header_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                }
                ]);
      addPlugins(config, 'mobile_header_slot', [
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'theme_switch_button',
                        type: DIRECT_PLUGIN,
                        RenderWidget: MobileViewHeader,
                    },
                },
                ]);
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
    if (process.env.APP_ID == 'learning') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
            {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
                id: 'custom_footer',
                type: DIRECT_PLUGIN,
                priority: 20,
                RenderWidget: () => (
                <DigiwindFooter />
                ),
            },
            
    }
  ]);
      addPlugins(config, 'learning_help_slot', [
        {
            op: PLUGIN_OPERATIONS.Hide,
            widgetId: 'default_contents',
        }
        ]);
      addPlugins(config, 'learning_help_slot', [
        {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
                id: 'theme_switch_button',
                type: DIRECT_PLUGIN,
                RenderWidget: ToggleThemeButton,
            },
        },
        ]);
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
    if (process.env.APP_ID == 'ora-grading') {
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
    if (process.env.APP_ID == 'profile') {
const { default: IndigoFooter } = await import('@edly-io/indigo-frontend-component-footer');
      addPlugins(config, 'org.openedx.frontend.layout.footer.v1', [
            {
                op: PLUGIN_OPERATIONS.Hide,
                widgetId: 'default_contents',
            },
            {
                op: PLUGIN_OPERATIONS.Insert,
                widget: {
                    id: 'read_theme_cookie',
                    type: DIRECT_PLUGIN,
                    priority: 2,
                    RenderWidget: AddDarkTheme,
                },
            },
            {
            op: PLUGIN_OPERATIONS.Insert,
            widget: {
                id: 'custom_footer',
                type: DIRECT_PLUGIN,
                priority: 20,
                RenderWidget: () => (
                <DigiwindFooter />
                ),
            },
            
    }
  ]);
      addPlugins(config, 'desktop_secondary_menu_slot', [
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'theme_switch_button',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ToggleThemeButton,
                    },
                },
        ]);
      addPlugins(config, 'mobile_header_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                }
                ]);
      addPlugins(config, 'mobile_header_slot', [
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'theme_switch_button',
                        type: DIRECT_PLUGIN,
                        RenderWidget: MobileViewHeader,
                    },
                },
                ]);
      addPlugins(config, 'logo_slot', [
                {
                    op: PLUGIN_OPERATIONS.Hide,
                    widgetId: 'default_contents',
                },
                {
                    op: PLUGIN_OPERATIONS.Insert,
                    widget: {
                        id: 'custom_logo',
                        type: DIRECT_PLUGIN,
                        RenderWidget: ThemedLogo,
                    }
                }
            ]);
    }
if (config.pluginSlots && config.pluginSlots['logo_slot']) {
  config.pluginSlots['logo_slot'].keepDefault = false;

  const logoInsertPlugins =
    config.pluginSlots['logo_slot'].plugins.filter(plugin => plugin.op === 'insert' && plugin.widget?.id === 'custom_logo');

  if (logoInsertPlugins.length > 1) {
    let kept = false;
    config.pluginSlots['logo_slot'].plugins =
      config.pluginSlots['logo_slot'].plugins.filter(plugin => {
        if (plugin.op === 'insert' && plugin.widget?.id === 'custom_logo') {
          if (kept) return false;
          kept = true;
        }
        return true;
      });
  }
}

if (config.pluginSlots && config.pluginSlots['org.openedx.frontend.layout.footer.v1']) {
  const footerPluginsToInsert =
    config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins.filter(plugin => plugin.op === 'insert');

  if (footerPluginsToInsert.length > 2) {
  config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins =
    config.pluginSlots['org.openedx.frontend.layout.footer.v1'].plugins.filter(plugin => {
      if (plugin.op === 'insert') {
        const widgetId = plugin.widget?.id;
        return widgetId !== 'indigo_footer';
      }
      return true;
    });
  }
}
  } catch (err) { console.error("env.config.jsx failed to apply: ", err);}

  return config;
}

export default setConfig;